import { seededShuffle } from './rng.js';

/**
 * Monta o baralho embaralhado do jogo da memória: cada carta selecionada vira um par
 * (uid _a/_b) e o baralho inteiro é embaralhado com Fisher-Yates (seededShuffle), não
 * apenas ordenado — caso contrário as duas cartas de um mesmo par ficam sempre vizinhas
 * e o jogo nunca muda de layout entre rodadas.
 */
export function buildDeck(game, level, seed = `${game?.id}:${level}:${Date.now()}:${Math.random()}`) {
  const pairCount = Number(game.paresPorNivel?.[level] || game.paresPorNivel?.[game.nivelInicial] || 4);
  const selected = (game.cartas || []).slice(0, pairCount);
  const pares = selected.flatMap((card) => [
    { ...card, uid: `${card.id}_a`, pairId: card.id },
    { ...card, uid: `${card.id}_b`, pairId: card.id },
  ]);
  return seededShuffle(pares, seed);
}

export function resultScore({ pairCount, matchedCount, attempts, errors, hints }) {
  if (!pairCount) return 0;
  const completion = matchedCount / pairCount;
  const efficiency = attempts ? Math.max(0, 1 - errors / attempts) : 0;
  const hintPenalty = Math.min(0.25, hints * 0.04);
  return Math.max(0, Math.round((completion * 0.7 + efficiency * 0.3 - hintPenalty) * 100));
}
